import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { ClientEnvironment, ENVIRONMENT } from '../environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private static chunkFailedMessage = /Loading chunk [\d]+ failed/;

  constructor(@Inject(ENVIRONMENT) private readonly env: ClientEnvironment) {}

  handleError(error: Error | HttpErrorResponse) {
    // log the error in local and dev environment
    if (['LOCAL', 'DEV'].includes(this.env.environment)) {
      console.error(error);
    }

    if (GlobalErrorHandler.chunkFailedMessage.test(error.message)) {
      console.log('Chunk failed, reloading the page');
      window.location.reload();
    }
  }
}
